<template>
  <b-row>
    <b-col>
      <div class="col-md-12">
        <b-card class="mb-2">
          <b-card-text>
            <b-row v-if="displayHeader">
              <b-col>
                <div><strong>Name</strong></div>
                <div>{{ paymentMethod.name  }}</div>
                <div><strong>Authorized</strong></div>
                <div>{{ paymentMethod.authorized }}</div>
              </b-col>
            </b-row>
            <b-row v-if="displayMethod">
              <b-col>
                <div><strong>Method</strong></div>
                <div>{{ map.method[paymentMethod.method]  }}</div>
              </b-col>
            </b-row>
            <check-display v-if="paymentMethod.method === 'check'" :check="method" />
            <bank-details-display v-else :bank-data="method" />
          </b-card-text>
        </b-card>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import CheckDisplay from '@/components/payments/display/CheckDisplay';
import BankDetailsDisplay from '@/components/payments/display/BankDetailsDisplay';


export default {
  components: {
    CheckDisplay,
    BankDetailsDisplay,
  },
  props: {
    paymentMethod: {
      type: Object,
      required: true,
    },
    displayHeader: {
      type: Boolean,
      default: true,
    },
    displayMethod: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      map: {
        method: {
          check: 'Check',
          transfer: 'Transfer',
          ach: 'ACH',
        },
      },
    };
  },
  computed: {
    method() {
      return this.paymentMethod[this.paymentMethod.method];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/payments/display/PaymentMethodDisplay.vue